import React, { useState, useRef, useEffect } from 'react';

const OfficeListDisplay = ({ offices, userRole, currentUserId, currentUserAreaSigla, onUploadSignedFile, allUsers, allAreas }) => {
    const [filterUser, setFilterUser] = useState('');
    const [filterArea, setFilterArea] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [searchTerm, setSearchTerm] = useState(''); 
    const [selectedOfficeForUpload, setSelectedOfficeForUpload] = useState(null);
    const [signedFile, setSignedFile] = useState(null);

    const fileInputRef = useRef(null);

    useEffect(() => {
        if (userRole === 'EMISOR') {
            setFilterUser(currentUserId); 
            setFilterArea(currentUserAreaSigla || ''); 
        } else {
            setFilterUser('');
            setFilterArea('');
        }
    }, [userRole, currentUserId, currentUserAreaSigla]); 

    const filteredOffices = offices.filter(office => {
        const matchesUser = filterUser ? (office.user && office.user.id === filterUser) : true;
        const matchesArea = filterArea ? (office.area && office.area.abbreviation === filterArea) : true; 
        const matchesStatus = filterStatus ? office.status === filterStatus : true;
        const matchesSearch = searchTerm ? office.folio.toLowerCase().includes(searchTerm.toLowerCase()) : true;

        if (userRole === 'EMISOR') {
            return matchesStatus && matchesSearch && (office.user && office.user.id === currentUserId);
        } else if (userRole === 'VISOR' || userRole === 'ADMIN') {
            return matchesUser && matchesArea && matchesStatus && matchesSearch;
        }
        return false; 
    });

    const handleUploadClick = (office) => {
        setSelectedOfficeForUpload(office);
        setSignedFile(null); 
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; 
        }
    };

    const handleFileChange = (event) => {
        setSignedFile(event.target.files[0]);
    };

    const handleConfirmUpload = () => {
        if (selectedOfficeForUpload && signedFile) {
            onUploadSignedFile(selectedOfficeForUpload.id, signedFile);
            setSelectedOfficeForUpload(null); 
            setSignedFile(null); 
            if (fileInputRef.current) {
                fileInputRef.current.value = ""; 
            }
        } else {
            alert("Por favor, selecciona un archivo firmado.");
        }
    };

    const handleCancelUpload = () => {
        setSelectedOfficeForUpload(null);
        setSignedFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; 
        }
    };

    //const selectedUserName = allUsers.find(user => user.id === filterUser)?.username || 'Cargando...';
    //const selectedAreaName = allAreas.find(area => area.abbreviation === filterArea)?.name || 'Cargando...';

    return (
        <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">Listado de Oficios</h2>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                {userRole !== 'EMISOR' && (
                    <>
                        <div>
                            <label htmlFor="filterUser" className="block text-gray-700 text-sm font-bold mb-2">Filtrar por Usuario:</label>
                            <select
                                id="filterUser"
                                className="shadow border rounded w-full py-2 px-3 text-gray-700"
                                value={filterUser}
                                onChange={(e) => setFilterUser(e.target.value)}
                            >
                                <option value="">Todos</option>
                                {allUsers.map(user => <option key={user.id} value={user.id}>{user.username}</option>)} 
                            </select>
                        </div>
                        <div>
                            <label htmlFor="filterArea" className="block text-gray-700 text-sm font-bold mb-2">Filtrar por Área:</label>
                            <select
                                id="filterArea"
                                className="shadow border rounded w-full py-2 px-3 text-gray-700"
                                value={filterArea}
                                onChange={(e) => setFilterArea(e.target.value)}
                            >
                                <option value="">Todas</option>
                                {allAreas.map(area => <option key={area.id} value={area.abbreviation}>{area.abbreviation} - {area.name}</option>)} 
                            </select>
                        </div>
                    </>
                )}
                {}
                
                <div>
                    <label htmlFor="filterStatus" className="block text-gray-700 text-sm font-bold mb-2">Filtrar por Estado:</label>
                    <select
                        id="filterStatus"
                        className="shadow border rounded w-full py-2 px-3 text-gray-700"
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                    >
                        <option value="">Todos</option>
                        <option value="PENDIENTE_FIRMA">PENDIENTE_FIRMA</option>
                        <option value="FIRMADO">FIRMADO</option>
                    </select>
                </div>
                <div>
                    <label htmlFor="searchTerm" className="block text-gray-700 text-sm font-bold mb-2">Buscar por Folio:</label>
                    <input
                        type="text"
                        id="searchTerm"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Buscar folio..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                    <thead>
                        <tr className="bg-gray-100 border-b">
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Folio</th>
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Nombre</th>
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Justificación</th>
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Estado</th>
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Original</th>
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Firmado</th>
                            {(userRole === 'EMISOR' || userRole === 'ADMIN') && (
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Acciones</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredOffices.length === 0 ? (
                            <tr>
                                <td colSpan={7} className="py-4 px-4 text-center text-gray-500">No hay oficios para mostrar.</td>
                            </tr>
                        ) : (
                            filteredOffices.map(office => {
                                const originalPdfUrl = office.original_pdf_url || null;
                                const signedPdfUrl = office.signed_pdf_url || null;

                                return (
                                    <tr key={office.id} className="border-b last:border-b-0 hover:bg-gray-50">
                                        <td className="py-2 px-4 text-sm text-gray-800">{office.folio}</td>
                                        <td className="py-2 px-4 text-sm text-gray-800">{office.name}</td>
                                        <td className="py-2 px-4 text-sm text-gray-800">{office.justification}</td>
                                        <td className="py-2 px-4 text-sm text-gray-800">{office.status}</td>
                                        <td className="py-2 px-4 text-sm">
                                            {originalPdfUrl ? (
                                                <a
                                                    href={originalPdfUrl} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="text-blue-500 hover:underline"
                                                >
                                                    Ver PDF
                                                </a>
                                            ) : (
                                                <span className="text-gray-500">No disponible</span>
                                            )}
                                        </td>
                                        <td className="py-2 px-4 text-sm">
                                            {signedPdfUrl ? (
                                                <a
                                                    href={signedPdfUrl} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="text-blue-500 hover:underline"
                                                >
                                                    Ver PDF Firmado
                                                </a>
                                            ) : (
                                                <span className="text-gray-500">No firmado</span>
                                            )}
                                        </td>
                                        {(userRole === 'EMISOR' || userRole === 'ADMIN') && (
                                            <td className="py-2 px-4 text-sm">
                                                {(office.status === 'PENDIENTE_FIRMA' && 
                                                  ((userRole === 'EMISOR' && office.user?.id === currentUserId) || userRole === 'ADMIN')) ? (
                                                    <button
                                                        className="bg-purple-500 hover:bg-purple-700 text-white font-bold py-1 px-3 rounded text-xs"
                                                        onClick={() => handleUploadClick(office)}
                                                    >
                                                        Subir Firmado
                                                    </button>
                                                ) : 
                                                (office.status === 'FIRMADO' && 
                                                  ((userRole === 'EMISOR' && office.user?.id === currentUserId) || userRole === 'ADMIN')) ? (
                                                    <span className="text-gray-500">Firmado</span>
                                                ) : 
                                                (
                                                    <span className="text-gray-500">N/A</span>
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>

            {selectedOfficeForUpload && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
                        <h3 className="text-xl font-bold mb-4">Subir Archivo Firmado para Folio: {selectedOfficeForUpload.folio}</h3>
                        <div className="mb-4">
                            <label htmlFor="signedFileUpload" className="block text-gray-700 text-sm font-bold mb-2">
                                Seleccionar PDF Firmado:
                            </label>
                            <input
                                type="file"
                                id="signedFileUpload"
                                accept=".pdf"
                                onChange={handleFileChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                ref={fileInputRef}
                            />
                        </div>
                        <div className="flex justify-end gap-2">
                            <button
                                className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"
                                onClick={handleCancelUpload}
                            >
                                Cancelar
                            </button>
                            <button
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                onClick={handleConfirmUpload}
                            >
                                Subir
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OfficeListDisplay;
